<template>
    <div style="width:100%;height:100%">
        <buttonlist
                ref="SetBtn"
                @help="help"
        ></buttonlist>
        <el-card class="box-card">
            <el-row style="display: flex;background: white">
                <el-button type="primary" size="mini" @click="download">{{$t('getapi[6506]')}}</el-button>
                <el-button type="primary" size="mini" @click="showitems">{{$t('getapi[4412]')}}</el-button>
                <el-button type="primary" size="mini" @click="remove">{{$t('getapi[437]')}}</el-button>
                <el-col :span="5" style="text-align: left">
                    <el-upload
                            class="upload-demo"
                            ref="upload"
                            :action="uploadurl"
                            :on-preview="handlePreview"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList"
                            :limit="1"
                            style="margin-left: 8px"
                    >
                        <el-button slot="trigger" size="mini" type="primary">{{$t('getapi[436]')}}</el-button>
                    </el-upload>
                    
                </el-col>
                <el-col :span="18" style="text-align: right">
                    <span style="padding:0 20px;">{{$t('getapi[506]')}}</span>
                    <el-select filterable v-model="editPlan" :placeholder="$t('getapi[6085]')" size="mini">
                        <el-option v-for="item in editPlanList" :key="item.value" :label="item.label"
                                   :value="item.value"></el-option>
                    </el-select></el-col>
                <el-col :span="2" style="text-align: right">
                    <el-button type="primary" size="mini" @click="updatecheck">{{$t('getapi[439]')}}</el-button>
                    <el-button type="primary" size="mini" @click="update" :disabled="!ischeck">{{$t('getapi[507]')}}</el-button>
                </el-col>
            </el-row>
        </el-card>
        <el-card class="box-card">
            <el-table
                    :data="dataSet"
                    v-loading="loading"
                    :highlight-current-row="true"
                    show-overflow-tooltip="true"
                    border
                    stripe
                    size="mini"
                    :height="tableHeight"
                    @cell-dblclick="editInfo"
                    tab-click="selectInfo(0)"
                    @selection-change="handleSelectionChange"
                    :row-class-name="tableRowClassName"
                    header-row-class-name="headerclass"
                    style="width: 100%; margin-top:0px"
                    ref="singleTable"
            >
                <el-table-column type="selection"></el-table-column>
                <!-- <el-table-column show-overflow-tooltip prop="exclusively_id" label="ID" v-if="false"></el-table-column> -->
                <el-table-column show-overflow-tooltip prop="DataStatus" :label="$t('getapi[504]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="vender_code" :label="$t('getapi[1287]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[112]')"></el-table-column>
                <el-table-column show-overflow-tooltip prop="routing_sequence_no" :label="$t('getapi[573]')"></el-table-column>
                
                <el-table-column :class-name="editPlan == 'shipment_cycle'?'check':''"
                                 prop="shipment_cycle" :label="$t('getapi[3597]')">
                    <template scope="scope">
                        <el-input class-name="check" size="small" v-model="scope.row.shipment_cycle"
                                  v-if="editPlan == 'shipment_cycle'"></el-input>
                        <span v-if="editPlan != 'shipment_cycle'">{{scope.row.shipment_cycle}}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'price' ? 'check' : ''" prop="price" :label="$t('getapi[1410]')"  >
                    <template scope="scope" >
                        <el-input class-name="check" size="small" v-model="scope.row.price"
                                  v-if="editPlan == 'price'" type="number" autocomplete="off" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'price'">{{ scope.row.price|tofixed4 }}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'order_addqty' ? 'check' : ''" prop="order_addqty" :label="$t('getapi[164]')"  >
                    <template scope="scope" >
                        <el-input class-name="check" size="small" v-model="scope.row.order_addqty"
                                  v-if="editPlan == 'order_addqty'" type="number" autocomplete="off" @mousewheel.native.prevent></el-input>
                        <span v-if="editPlan != 'order_addqty'">{{ scope.row.order_addqty|tofixed4 }}</span>
                    </template>
                </el-table-column>
                <el-table-column :class-name="editPlan == 'Process_Remark' ? 'check' : ''" prop="Process_Remark" :label="$t('getapi[6702]')"  >
                    <template scope="scope" >
                        <el-input class-name="check" size="small" v-model="scope.row.Process_Remark"
                                  v-if="editPlan == 'Process_Remark'"></el-input>
                        <span v-if="editPlan != 'Process_Remark'">{{ scope.row.Process_Remark}}</span>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="unit_price" label="ID" v-if="false"></el-table-column> 
                <el-table-column show-overflow-tooltip prop="net_unit_price" label="ID" v-if="false"></el-table-column> 
                <el-table-column show-overflow-tooltip prop="part_id" label="ID" v-if="false"></el-table-column> 
                <el-table-column show-overflow-tooltip prop="part_version" label="ID" v-if="false"></el-table-column> 
                <el-table-column show-overflow-tooltip prop="tax_flag" label="ID" v-if="false"></el-table-column> 
                <el-table-column show-overflow-tooltip prop="tax_rate" label="ID" v-if="false"></el-table-column> 


            </el-table>
        </el-card>
        <selector :isVisible="itevisible" :isBatch=true :selectType="0" :isSplitPage=true
                  :postUrl="'/Iss/QuotationBatch/GetWxPriceInfoPopupList'" @callback="getitembom" ref="input"></selector>
    </div>
</template>
<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import CommonHeader from '@/components/CommonHeader';

    export default {
        name: 'wxpricebatchupdate',
        data() {
            return {
                itevisible: false,
                dataSet: [],
                dataChecked: [], // 选中的ID集合
                loading: false, // 主表加载状态
                tableHeight: window.innerHeight - 178, // 主表高度
                uploadurl: '',
                fileList: [],
                editPlan: '0',
                editPlanList: [{
                    value: '0',
                    label: this.$t('getapi[852]')//'未选择'
                }, {
                    value: 'price',
                    label: this.$t('getapi[1410]')//'单价'
                },
                {
                    value: 'shipment_cycle',
                    label: this.$t('getapi[3597]')//'交货周期'
                },
                {
                    value: 'order_addqty',
                    label: this.$t('getapi[164]')//'订单增量'
                },
                {
                    value: 'Process_Remark',
                    label: this.$t('getapi[6702]')//'加工要求'
                },],
                scrollTop:0,
                ischeck:false,
            };
        },
        beforeMount() {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            let token = JSON.parse(that.userData).token;
            that.uploadurl = Common.Url + '/Iss/QuotationBatch/WxPriceInfoImportUpFile?token=' + token;
        },
        mounted: function () {
            let that = this;
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6012]"),this.$t("getapi[18]"));
            },
            //按钮操作权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                // //只读权
                that.$refs.SetBtn.SetButtonEnable('');
            },
            // 新物料打开
            showitems() {
                this.itevisible = true;
                this.$refs.input.clearInput(this.itevisible);
            },
            download(){
                let param={
                    url:'/Iss/QuotationBatch/WxPriceInfoTemplate'
                }
                Array.methods.DownLoadTemp(param);
            },
            getitembom(data) {
                let that = this
                if(data.length > 0){                 
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            vender_code: data[i].vender_code,
                            part_code: data[i].part_code,
                            routing_sequence_no: data[i].routing_sequence_no,
                            price: data[i].price,
                            shipment_cycle: data[i].shipment_cycle,    
                            order_addqty: data[i].order_addqty,                                     
                            DataStatus: data[i].DataStatus,
                            Process_Remark:data[i].Process_Remark,
                        }]
                    }
                }
            },
            handleSelectionChange(val) {
                let that = this;
                for (let i = 0; i < val.length; i++) {
                    that.dataChecked.push(val[i].part_code);
                }
            },
            remove() {
                let that = this
                let arr = that.dataSet.filter(item => {
                    return that.dataChecked.every(item2 => {
                        return item.part_code != item2
                    })
                })
                that.dataSet = arr;
                that.fileList = [];
            },
            handleChange(file, fileList) {
                let that = this;
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                let response = res.Success;

                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    let data = res.DataContent
                    data = data.filter(item => {
                        return that.dataSet.every(item2 => {
                            if( item.vender_code != item2.vender_code  && item.part_code != item2.part_code && item.routing_sequence_no != item2.routing_sequence_no){
                                return;
                            }

                        });
                    });
                    for (let i = 0; i < data.length; i++) {
                        that.dataSet = [...that.dataSet, {
                            vender_code: data[i].vender_code,
                            part_code: data[i].part_code,
                            routing_sequence_no: data[i].routing_sequence_no,
                            price: data[i].price,
                            shipment_cycle: data[i].shipment_cycle,    
                            order_addqty: data[i].order_addqty,                                     
                            DataStatus: data[i].DataStatus,
                            Process_Remark:data[i].Process_Remark,
                        }]
                    }
                    that.dataSet = res.DataContent
                    that.ischeck=false;
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(this.$t('getapi[8585]')+':' + err);
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            updatecheck(){
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let parm = {
                    PageIndex: 0,
                    PageSize: 0,
                    Param: that.dataSet,
                    id: "",
                    name: that.editPlan
                };
                that.$http.urlpost('/Iss/QuotationBatch/WxPriceInfoEnableCheck', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataSet= res.DataContent;
                        that.ischeck=true;
                    }
                });
            },
            update() {
                let that = this;
                if (that.editPlan == '0') {
                    that.$message.warning(that.$t('getapi[8625]'));//'请选择更新字段'
                    return
                }
                let parm = {
                    PageIndex: 0,
                    PageSize: 0,
                    Param: that.dataSet,
                    id: "",
                    name: that.editPlan
                };
                that.$http.urlpost('/Iss/QuotationBatch/WxPriceInfoUpdate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                    }
                });
            }
        }
    };
</script>

<style scoped lang="less">
    .c-search-table {
        width: 100%;
        height: calc(~'100% - 10px'); /*这里我用了计算属性*/
    }

    .beauty-Scroll {
        .el-scrollbar {
            height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
        }
        .el-scrollbar__wrap {
            width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
            height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
        }
    }

    input {
        width: 100%;
        height: 35px;
        border-radius: 8px;
        border: 1px solid #dcdfe6;
        padding-left: 2px;
        padding-right: 2px;
    }

    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
        }
    }

    .alignment-left {
        text-align: left;
    }

    .alignment-right {
        text-align: right;
    }

    .el-pagination {
        white-space: inherit;
    }
</style>
